import { useMutation } from '@tanstack/react-query'

import { createDocumentTemplateFromPdf } from '@flecto/api/shared'
import { type CoreBookingDocument } from '@flecto/types'

type MutationPayload = {
  document: CoreBookingDocument
  external_id: string
  application_key: string
}

export function useMutationCreateDocumentTemplateFromPdf() {
  return useMutation({
    mutationKey: ['MutationCreateDocumentTemplateFromPdf'],
    mutationFn: async ({
      document,
      external_id,
      application_key,
    }: MutationPayload) =>
      await createDocumentTemplateFromPdf(
        document,
        external_id,
        application_key
      ),
  })
}
